import { render, staticRenderFns } from "./UpsertPermission.vue?vue&type=template&id=6a43ae3b"
import script from "./UpsertPermission.vue?vue&type=script&lang=js"
export * from "./UpsertPermission.vue?vue&type=script&lang=js"
import style0 from "./UpsertPermission.vue?vue&type=style&index=0&id=6a43ae3b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports